export default {"src":"/_next/static/media/404.d5405216.svg","height":369,"width":745};